export const capitalizeFirstLetter = (title: string): string => {
    return title ? `${title[0].toUpperCase()}${title.substr(1)}` : '';
};
